<template>
  <div>
    <vs-popup title="Adicionar Conexões" :active.sync="addInstancePopupActive" class="sizePopup">
      <table-instances
        :instances="instancesAvailable"
        @saveInstancesOnCustomer="attachInstancesOnCustomer"
        :addInstancePopupActive="addInstancePopupActive"
      />
    </vs-popup>

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ this.user.id === null || this.user.id === undefined ? "ADICIONAR NOVO" : "ATUALIZAR" }} USUÁRIO</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="cancelOperation"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
        ref="formPS"
      >
          <div class="p-6" ref="form">
            <!-- NAME -->
            <vs-input
              label="Nome"
              v-model="user.name"
              class="mt-5 w-full"
              name="name"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('name')"
            >
              {{ errors.first('name') }}
            </span>

            <!-- USERNAME -->
            <vs-input
              label="Usuário"
              v-model="user.username"
              class="mt-5 w-full"
              name="username"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('username')"
            >
              {{ errors.first('username') }}
            </span>

            <!-- EMAIL -->
            <vs-input
              label="Email"
              v-model="user.email"
              class="mt-5 w-full"
              name="email"
              v-validate="'required|email|regex:(.com)'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('email')"
            >
              {{ errors.first('email') }}
            </span>

            <!-- ROLES -->
            <vs-select
              v-model="user.role.id"
              label="Permissão"
              class="mt-5 mb-5 w-full"
              name="role"
              v-validate="'required'"
              autocomplete
            >
              <vs-select-item
                :key="item.value"
                :value="item.value"
                :text="item.text"
                v-for="item in roleChoices"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('role')"
            >
              {{ errors.first('role') }}
            </span>

            <!-- DEPARTMENTS -->
            <label class="vs-input--label" for="department">Departamento</label>
            <v-select
              v-model="user.userDepartment.id"
              :options="departmentChoices"
              :reduce="departmentChoices => departmentChoices.value"
              label="text"
              name="department"
            ></v-select>

            <!-- PASSWORD -->
            <vs-input
              v-if="this.activeUser.role.name === 'administrador' ? true : (this.user.id === null || this.user.id === undefined)"
              :label="this.user.id === null || this.user.id === undefined ? 'Senha' : 'Nova Senha'"
              :type="showPassword ? 'text' : 'password'"
              v-model="user.password"
              class="mt-5 w-full"
              name="password"
              v-validate="this.user.id === null || this.user.id === undefined ? 'required|min:8' : 'min:8'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('password')"
            >
              {{ errors.first('password') }}
            </span>

            <!-- CONFIRM PASSWORD -->
            <vs-input
              v-if="this.activeUser.role.name === 'administrador' ? true : (this.user.id === null || this.user.id === undefined)"
              label="Confirme a Senha"
              :type="showPassword ? 'text' : 'password'"
              v-model="confirmPassword"
              class="mt-5 w-full"
              :disabled="user.password ? false : true"
            />

            <vs-checkbox class="mt-2" v-model="showPassword">
              Exibir Senha
            </vs-checkbox>
            
            <span v-if="this.activeUser.role.name === 'administrador' ? true : (this.user.id === null || this.user.id === undefined)">
              <password-strong :password="user.password"></password-strong>
            </span>
            <div class="w-full  mt-5 mb-5">
              <h3>Conexões</h3>
              <ul class="mt-3">
                <li>
                  <vs-radio 
                    v-model="chooseConnections" 
                    vs-name="chooseConnections" 
                    vs-value="none"
                  >
                    Nenhuma Conexão
                  </vs-radio>
                </li>

                <li>
                  <vs-radio 
                    v-model="chooseConnections" 
                    vs-name="chooseConnections" 
                    vs-value="choose"
                  >
                    Escolher Conexões
                  </vs-radio>
                </li>
              </ul>

              <div v-if="chooseConnections === 'choose'">
                <vs-chip
                  :key="`instances-${index}`"
                  @click="removeInstance(instance)"
                  v-for="(instance, index) in instances"
                  closable
                  color="primary"
                  class="mt-3 mr-3"
                  style="font-size: 0.9rem;"
                >
                  {{ instance.instance.name }}
                </vs-chip>

                <vs-chip
                  @click="addInstances"
                  closable
                  close-icon="add"
                  class="mt-3 mr-3"
                  style="font-size: 0.9rem;"
                >
                  Adicionar Conexão
                </vs-chip>
              </div>
            </div>

            <br v-if="chooseConnections === 'choose'">

            <div v-if="hasErpFeature">
              <div class="w-full mt-5 " >
                <h3 style="display:inline-block;">Vincular usuário com ERP</h3>

                <div>
                  <vs-button class="p-2 pl-3 pr-3 mt-3" style="border-radius: 20px; margin-top:9px; font-size:15px;" @click="openModalToIntegration">
                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                    Vincular com ERP 
                  </vs-button>
                  
                  <h5 class="mt-5" v-if="this.selectedData.length > 0">Usuários para vincular</h5>

                  <span v-if="selectedData">
                    <p class="mt-3 mb-2 d-flex align-items-center" v-for="(data, index) in selectedData" :key="index">
                      <span class="flex-grow-1 pr-1">{{ data.user_integration_name }} ({{ data.erp_name }})</span>
                      <vs-icon @click="removeErpUser(index)" class="ml-1 remove-selected-erp-user" icon="close" ></vs-icon>
                    </p>
                    
                  </span>                
                </div>

                <div v-if="updateErpUserData">

                  <h5 class="mt-5" v-if="this.updateErpUserData.length > 0">Usuários Vinculados</h5>
                  <p class="mt-3 mb-2 d-flex align-items-center" v-for="(data, index) in updateErpUserData" :key="index">
                    <span class="flex-grow-1 pr-1">{{ data.user_integration_name }} ({{ data.erp.corporate_name }})</span>
                    
                    <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    style="cursor:pointer;"
                    @click.stop="deleteErpUser(data.id, data.user_id)"
                  />
                  </p>
                </div>

              </div>
            </div>
          </div>
      </VuePerfectScrollbar>

      <UserErpModal
      :isActive="modalChoiceERP"
      @isActiveFalse="modalChoiceERP=false"
      @listERPs="handleListERPs"
      @erpUserData="erpUserData"
      />

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
          Salvar
        </vs-button>
        <vs-button type="border" color="danger" @click="cancelOperation">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import TableInstances from './TableInstances'

import vSelect from 'vue-select'
import moduleRole from "@/store/role/moduleRole"
import moduleUserDepartment from "@/store/userDepartment/moduleUserDepartment"

import UserErpModal from './UserErpModal.vue'
import ErpUser from '@/http/requests/erpUser'
import { hasFeature, filterPassword } from '@/utils'

import PasswordStrong from "@/components/password-strong/password-strong.vue"

export default {
  name: 'user-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          username: '',
          email: '',
          password: '',
          role: {
            id: '',
            name: ''
          },
          userDepartment: {
            id: null,
            name: '',
            activated: false 
          }
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      instances: [],
      addInstancePopupActive: false,
      instancesAvailable: [],
      chooseConnections: '',
      chooseERPs: '',
      modalChoiceERP: false,
      dataToCreate: {},
      selectedData: [],
      updateErpUserData: [],
      newUserId: null,
      confirmPassword: null,
      showPassword: false,
    }
  },
  watch: {
    'user.role': function(role) {
      if (!role) {
        this.user.role = {
          id: '',
          name: ''
        }
      } 
    },
    user: function () {
      this.confirmPassword = null;
      this.showPassword = false

      if (this.user.id) {
        this.$store.dispatch("user/fetchInstances", this.user.id).then(res => {
          this.instances = res.data.data.userInstances

          if (this.instances.length) {
            this.chooseConnections = 'choose'
          } else {
            this.chooseConnections = 'none'
          }
        })
        this.getErpUsers(this.user.id);
      } else {
        this.instances = []
      }
    },
    addInstancePopupActive: function (val) {
      if (val) {
        const removeIds = this.instances.map(({ instance }) => instance.id)

        this.$store.dispatch("user/fetchDiffInstances", removeIds).then(res => {
          const { instances } = res.data.data
          this.instancesAvailable = instances.map(instance => ({
            id: null,
            instance
          }))
        }).catch(err => {
          console.error(err)
        })
      }
    },
    chooseConnections: function (val) {
      if (val === 'none') {
        this.instances = []
      }
    },
  },
  computed: {
    activeUser() {
      return this.$store.state.AppActiveUser;
    },
    roles() {
      return this.$store.state.role.roles
    },
    roleChoices() {
      const roleChoices = []

      for (const role of this.roles) {
        roleChoices.push({
          text: role.display_name,
          value: role.id
        })
      }

      return roleChoices
    },
    departments() {
      return this.$store.state.userDepartment.userDepartments
    },
    departmentChoices() {
      const departmentChoices = []

      for (const department of this.departments) {
        departmentChoices.push({
          text: department.name,
          value: department.id
        })
      }

      return departmentChoices
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          this.passwordStrength = 0
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    initValues() {
      this.user = {
        id: null,
        name: '',
        username: '',
        email: '',
        password: '',
        role: {
          id: '',
          name: ''
        },
        userDepartment: {
          id: null,
          name: '',
          activated: false 
        },
      }
    },
    addInstances() {
      this.addInstancePopupActive = true
    },
    attachInstancesOnCustomer(selectedInstances) {
      this.addInstancePopupActive = false
      
      this.instances = [
        ...this.instances,
        ...selectedInstances
      ]
    },
    removeInstance (instance) {
      if (instance.id) {
        this.$store.dispatch("user/deleteInstance", instance.id).then(() => {
          this.instances.splice(this.instances.indexOf(instance), 1)
        }).catch(err => {
          console.error(err)
        })
      } else {
        this.instances.splice(this.instances.indexOf(instance), 1)
      }
    },
    submitData() {
      if (this.user.password && this.user.password !== this.confirmPassword) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Atenção!',
          text: 'As senhas não são iguais'
        })
      }
      const that = this
      this.$validator.validateAll().then(result => {
      if(this.user.role.name !== 'administrador'){
        if (this.chooseConnections === '') {
          const scrollTop = this.$refs.form.scrollHeight
          this.$refs.formPS.$el.scrollTop = scrollTop

          return this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: 'Escolha uma opção de conexão para continuar'
          })
        }
      }

        this.user.chosenInstances = this.instances.map(({ instance }) => instance.id)
      if (this.user.role.name === 'administrador' && this.password) {
        const passwordStrength = filterPassword(this.user.password);
        if (passwordStrength <= 75) {
          return this.$vs.notify({
            color: 'danger',
            title: 'Senha inválida!',
            text: 'A senha precisa ser forte para que as alterações sejam salvas'
          });
        }
      }

        if (result) {
          if (this.user.id !== null && this.user.id >= 0) {
            this.$store.dispatch("user/update", this.user).then(() => {
              
              this.selectedData.forEach(data => {
                data.user_id = this.user.id
                this.submitErpUserData(data);
              });
              that.initValues()
              this.$emit('closeSidebar')
              this.$vs.notify({
                color: 'success',
                title: 'Sucesso!',
                text: 'Ajustes realizados com sucesso!'
              });
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.user.id
            this.$store.dispatch("user/add", this.user).then((response) => {

              let userId = response.data.data.newUser.user.id;
              this.selectedData.forEach(data => {
                data.user_id = userId
                this.submitErpUserData(data);
              });
              
              that.initValues()
              this.$emit('closeSidebar')
              this.$vs.notify({
                color: 'success',
                title: 'Sucesso!',
                text: 'Usuário criado com sucesso!'
              });
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    },
    submitErpUserData(data) {

      ErpUser.create(data)
      .then(() => {
         this.selectedData = [];       
      })
      .catch(error => {
        console.log(error);
      });

    },
    openModalToIntegration() {
      this.modalChoiceERP = true;
    },
    handleListERPs(list) {
      this.erpList = list;
    },
    erpUserData(dataToCreate) {
      this.dataToCreate = dataToCreate;
      
      if (this.selectedData !== [] && this.selectedData.some(item => item.erp_id === this.dataToCreate.erp_id) 
      ||this.updateErpUserData[0] !== undefined && this.updateErpUserData.some(item => item.erp.id === this.dataToCreate.erp_id)) {
        
        return this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: 'Esse usuário já está vinculado a essa ERP'
          })
      }  
      else {
        this.selectedData.push(this.dataToCreate);
      }
    },
    deleteErpUser(id, userId) {      
      ErpUser.delete(id)
      .then(() => {
        this.getErpUsers(userId);      
      })
      .catch(error => {
        console.log(error);
      });  
    },
    getErpUsers(userId) {
      ErpUser.fetchWithUserId(userId)
      .then(response => {
        this.updateErpUserData = response.data.data.getErpUser;      
      })
      .catch(error => {
        console.log(error);
      });
    },
    removeErpUser(index) {
      this.selectedData.splice(index, 1);      
    },
    cancelOperation() {
      this.isSidebarActiveLocal = false;
      this.updateErpUserData = [];
      this.selectedData = [];
    }
  },
  created() {
    if (!moduleRole.isRegistered) {
      this.$store.registerModule('role', moduleRole)
      moduleRole.isRegistered = true
    }

    this.$store.dispatch("role/fetch")

    if (!moduleUserDepartment.isRegistered) {
      this.$store.registerModule('userDepartment', moduleUserDepartment)
      moduleUserDepartment.isRegistered = true
    }

    this.$store.dispatch("userDepartment/fetch")
  },
  async mounted() {
    this.hasErpFeature = await hasFeature('erps')
  },
  components: {
    VuePerfectScrollbar,
    TableInstances,
    vSelect,
    UserErpModal,
    PasswordStrong
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.bullet-list {
  list-style-type: circle;
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.remove-selected-erp-user {
  font-size: 18px;
  background-color: #ebebeb;
  padding:1px;
  border-radius: 10px;
  cursor: pointer;
}
.green {
  color:  #46c93a;
}

.red {
  color: #ff4757;
}
.warning {
  display: flex;
  align-items: center;
  background-color: #fff7d0;
  color: #b29400;
  padding: 15px;
  border-radius: 6px;
  border: 2px solid #b29400;
  margin-top: 10px;
}

.warning .icon {
  margin-right: 20px;
  font-size: 24px;
}

.warning h4 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #b29400;
}

.warning p {
  font-size: 14px;
  line-height: 1.4;
}
.font-bold{
  font-weight: bold;
}

</style>
